const ICONS = ["/nz-icon-navy.png", "/nz-icon-blue.png"];

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const isMobile = () =>
  typeof window !== "undefined" && window.innerWidth < 768;

const isLowPerf = () =>
  typeof navigator !== "undefined" &&
  navigator.hardwareConcurrency &&
  navigator.hardwareConcurrency <= 4;

const makeIcon = (size, opacity) => {
  const img = document.createElement("img");
  img.src = ICONS[Math.floor(Math.random() * ICONS.length)];
  img.alt = "";
  img.setAttribute("aria-hidden", "true");
  img.style.position = "fixed";
  img.style.width = `${size}px`;
  img.style.height = `${size}px`;
  img.style.pointerEvents = "none";
  img.style.willChange = "transform, opacity";
  img.style.opacity = String(opacity);
  return img;
};

const makeLayer = () => {
  const layer = document.createElement("div");
  layer.style.position = "fixed";
  layer.style.inset = "0";
  layer.style.pointerEvents = "none";
  layer.style.zIndex = "9999";
  layer.style.overflow = "hidden";
  document.body.appendChild(layer);
  return layer;
};

// One-time celebratory inward burst from left & right edges (per session)
export const runEntryBurst = () => {
  if (typeof window === "undefined") return;
  if (prefersReducedMotion()) return;
  if (sessionStorage.getItem("nz_entry_burst")) return;
  sessionStorage.setItem("nz_entry_burst", "1");

  const layer = makeLayer();
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const perSide = isMobile() || isLowPerf() ? 5 : 10;

  const spawnSide = (fromLeft) => {
    for (let i = 0; i < perSide; i++) {
      const size = 16 + Math.random() * 16;
      const icon = makeIcon(size, 0.9);
      const startX = fromLeft ? -40 : vw + 40;
      const startY = vh * (0.25 + Math.random() * 0.5);
      const endX = fromLeft
        ? vw * (0.25 + Math.random() * 0.3)
        : vw * (0.45 + Math.random() * 0.3);
      const endY = startY + (Math.random() * 160 - 80);
      icon.style.left = `${startX}px`;
      icon.style.top = `${startY}px`;
      layer.appendChild(icon);

      const dur = 1200 + Math.random() * 600;
      const rot = (fromLeft ? 1 : -1) * (120 + Math.random() * 240);
      const anim = icon.animate(
        [
          { transform: "translate(0,0) rotate(0deg)", opacity: 0 },
          { opacity: 0.95, offset: 0.15 },
          {
            transform: `translate(${endX - startX}px, ${endY - startY}px) rotate(${rot}deg)`,
            opacity: 0,
          },
        ],
        { duration: dur, easing: "cubic-bezier(0.16, 1, 0.3, 1)", fill: "forwards" }
      );
      anim.onfinish = () => icon.remove();
    }
  };

  spawnSide(true);
  spawnSide(false);
  setTimeout(() => layer.remove(), 2200);
};

// Short falling-logo burst localized around a clicked element
export const dropBurstFromElement = (el) => {
  if (typeof window === "undefined" || !el) return;
  if (prefersReducedMotion()) return;

  const rect = el.getBoundingClientRect();
  const layer = makeLayer();
  const count = isMobile() || isLowPerf() ? 6 : 6 + Math.floor(Math.random() * 5); // 6-10
  const centerX = rect.left + rect.width / 2;
  const topY = rect.top;

  for (let i = 0; i < count; i++) {
    const size = 14 + Math.random() * 12;
    const icon = makeIcon(size, 0.35 + Math.random() * 0.25);
    const startX = centerX + (Math.random() * rect.width - rect.width / 2);
    const startY = topY + (Math.random() * 20 - 10);
    icon.style.left = `${startX}px`;
    icon.style.top = `${startY}px`;
    layer.appendChild(icon);

    const dur = 1000 + Math.random() * 500;
    const drift = Math.random() * 40 - 20;
    const rot = Math.random() * 160 - 80;
    const anim = icon.animate(
      [
        { transform: "translate(0,0) rotate(0deg)", opacity: 0 },
        { opacity: 0.5, offset: 0.2 },
        {
          transform: `translate(${drift}px, ${70 + Math.random() * 50}px) rotate(${rot}deg)`,
          opacity: 0,
        },
      ],
      { duration: dur, easing: "cubic-bezier(0.4, 0, 0.6, 1)", fill: "forwards" }
    );
    anim.onfinish = () => icon.remove();
  }

  setTimeout(() => layer.remove(), 1700);
};
